import React, { useEffect, useRef } from "react";
import isMobile from '../utils/ismobile'
import styled from 'styled-components'
import PageWrapper from "./pageWrapper";
import { breakpoint } from 'styled-components-breakpoint';
import { Link } from "react-scroll";

const HeaderWrapper = styled.header`
    position: fixed;
    width: 100%;
    background-color: #fff;
    z-index: 100;
    top: 0;
`

const Logo = styled.div`
    margin: 0 auto;
    width: 150px;
    ${breakpoint('mobile')`
        width: 200px;
    `}
    img{
        width: 100%;
    }
`

const Navigation = styled.nav`
    background-color:  ${props => props.theme.green1};
    padding: 5px 0;
    border-bottom: 2px solid ${props => props.theme.grey1};
    ul{
        list-style: none;
        margin: 0;
        text-align: left;
        padding: 0;
        li{
            display: inline-block;
            ${breakpoint('mobile')`
                font-size: 20px;
            `}
            margin:0px 5px 0 0;
            color: #fff;
            font-weight: 400;
            a{
                display: inline-block;
                padding: 3px 10px;

                ${breakpoint('mobile')`
                    padding: 3px 20px;
                `}
                &.active,
                &:hover{
                    cursor: pointer;
                    color:  ${props => props.theme.brown1};
                    background-color: #fff;
                }
            }
        }
    }
`
function SiteHeader(props) {

    const mobile = isMobile();
    const refHeader = useRef(null);
    let logoImage = (mobile) ? props.content.logoMobile.fields.file.url : props.content.logoDesktop.fields.file.url
    let sections = props.content.sections;

    useEffect(() => {

    });
    return(
        <HeaderWrapper ref={refHeader}>
            <PageWrapper>
                <Logo>
                    <Link activeClass="active" to="topimage" spy={true} smooth={true} offset={-220} duration={1000}><img src={logoImage} alt="truffelhond.nl" /></Link>
                </Logo>
            </PageWrapper>
            <Navigation>
                <PageWrapper>
                    <ul>
                        <li><Link activeClass="active" to="topimage" spy={true} smooth={true} offset={-220} duration={1000}>Home</Link></li>
                        {(sections) ? sections.map((item, key) => {
                            return (
                                <li key={key}>
                                    <Link activeClass="active" to={`section${key}`} spy={true} smooth={true} offset={-220} duration={1000}>{item.fields.sectionName}</Link>
                                </li>
                                )
                        }) : ""}
                    </ul>
                </PageWrapper>
            </Navigation>
        </HeaderWrapper>
    )
}

export default SiteHeader;